import Button, { ButtonProps } from "./button";

export { Button, type ButtonProps };
